import {
  GETUSERBYPARTY,
  axios,
  config,
  LOGINAUTH,
  LOGINULL,
  baseURL,
  CREATEUSER,
  GETUSER,
  UPDATEUSER,
  GETUSERBYROLL,
  UPDATEUSERBYMOBAIL,
  DELETEUSER,
  GENERATECAPTCHA,
  GETALLUSERSFILTER,
  GETUSERDATA,
} from './types';

export const handleloginnull = (value) => {
  return {
    type: LOGINULL,
    payload: value,
  }
}
// changes made by Mansi
export const handlelogin = (mobile, password, captchaUuid, captchaInput) => dispatch => {
  let loginObject = {}
  loginObject.mobile = mobile
  loginObject.password = password
  loginObject.captchaUuid = captchaUuid
  loginObject.captchaInput = captchaInput

  var config = {
    method: 'post',
    url: baseURL + '/api/users/login',
    headers: {
      'Content-Type': 'application/json'
    },
    data: loginObject
  };

  return axios(config)
    .then(function (response) {
      if (response.data && response.data.data && response.data.data.username) {
        localStorage.setItem('username', response.data.data.username);
      }
      dispatch({
        type: LOGINAUTH,
        payload: response.data,
      })
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
}
export const GenerateCaptcha = (data) => dispatch => {

  var config = {
    method: 'post',
    url: baseURL + '/api/hospitalcaptcha/generate',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: data
  };

  return axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data))
      dispatch({
        type: GENERATECAPTCHA,
        payload: response.data
      })
    })
    .catch(function (error) {
      console.log(error);
    });

}
// end of changes made by Mansi

// export const handlelogin = (mobile, password) => dispatch => {
//   let loginObject = {}
//   loginObject.mobile = mobile
//   loginObject.password = password
//   var config = {
//     method: 'post',
//     url: baseURL + '/api/users/login',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: loginObject
//   };

//   return axios(config)
//     .then(function (response) {
//       if (response.data && response.data.data && response.data.data.username) {
//         localStorage.setItem('username', response.data.data.username);
//       }
//       dispatch({
//         type: LOGINAUTH,
//         payload: response.data,
//       })


//     })
//     .catch(function (error) {
//       console.log(error);

//     });

//   // return axios.post("api/users/login", loginObject, config).then(res => {
//   //     console.log(res)
//   //     dispatch({
//   //         type: LOGINAUTH,
//   //         payload: res.data
//   //     })
//   // })
// }

// export const handlelogin = (mobile, password) => (dispatch) => {
//   const loginObject = { mobile, password };

//   const config = {
//     method: 'post',
//     url: `${baseURL}/api/users/login`,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: loginObject,
//   };

//   return axios(config)
//     .then((response) => {
//       const { username, token } = response.data.data; // Ensure username is extracted correctly
//       console.log("login payload:", { username});
//       localStorage.setItem('userName', username);  // Store username
//       // localStorage.setItem('authToken', token);   // Store auth token

//       // Dispatch the username and token as part of the payload
//       dispatch({
//         type: LOGINAUTH,
//         payload: { username },  // Make sure username and token are in the payload
//       });
//     })
//     .catch((error) => {
//       console.error('Login failed:', error.response?.data?.error || error.message);
//     });
// };


export const createUser = (UserData) => dispatch => {
  var config = {
    method: 'post',
    url: baseURL + '/api/users/create',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEUSER,
        payload: response.data
      })
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });

}
export const updateUser = (UserData) => dispatch => {
  var config = {
    method: 'patch',
    url: baseURL + '/api/users/update',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEUSER,
        payload: response.data
      })
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });

}


export const updateUser1 = (UserData) => dispatch => {
  var config = {
    method: 'patch',
    url: baseURL + '/api/users/updatebymobail',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEUSERBYMOBAIL,
        payload: response.data
      })
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });

}
export const getUser = (UserData) => dispatch => {

  var config = {
    method: 'get',
    // url: baseURL+'/api/users/userrole',
    url: baseURL + '/api/users/getall',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  return axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data))
      dispatch({
        type: GETUSER,
        payload: response.data
      })
    })
    .catch(function (error) {
      console.log(error);
    });

}


export const getUserbyroll = (UserData) => dispatch => {

  var config = {
    method: 'post',
    // url: baseURL+'/api/users/userrole',
    url: baseURL + '/api/users/getallbyroll',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data))
      dispatch({
        type: GETUSERBYROLL,
        payload: response.data
      })
    })
    .catch(function (error) {
      console.log(error);
    });

}

export const deleteUser = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/users/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEUSER,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getUserByParty = (UserData) => dispatch => {

  var config = {
    method: 'post',
    // url: baseURL+'/api/users/userrole',
    url: baseURL + '/api/users/getallparty',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: UserData
  };

  return axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data))
      dispatch({
        type: GETUSERBYPARTY,
        payload: response.data
      })
    })
    .catch(function (error) {
      console.log(error);
    });

}

export const getAllUsersFilter = (filterData) => dispatch => {
  var config = {
    method: 'post',
    url: baseURL + '/api/users/getallusers/filter',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: filterData
  };

  return axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      dispatch({
        type: GETALLUSERSFILTER,
        payload: response.data
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const getUserData = (filterData) => dispatch => {
  var config = {
    method: 'post',
    url: baseURL + '/api/users/getalluser',
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data: filterData
  };

  return axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      dispatch({
        type: GETUSERDATA,
        payload: response.data
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};